import React from "react";
import { Link } from "react-router-dom";
//Import media
// import Farming from "../components/Farming";
import Video from "../components/Video";
import bgArcade from "../videos/bg-video-arcade.mp4";
import thumb1 from "../images/thmb-qte.svg";
// import PureCounter from "@srexi/purecounterjs";
import smallLogo from "../images/logo-quantum-small-v2.svg";
import "../styles/quantum.css";

// This is the Hardhat Network id that we set in our hardhat.config.js.
// Here's a list of network ids https://docs.metamask.io/guide/ethereum-provider.html#properties
// to use when deploying to other networks.
const HARDHAT_NETWORK_ID = "1";

// This is an error code that indicates that the user canceled a transaction
const ERROR_CODE_TX_REJECTED_BY_USER = 4001;

// This component is in charge of doing these things:
//   1. It connects to the user's wallet
//   2. Initializes ethers and the Token contract
//   3. Polls the user balance to keep it updated.
//   4. Transfers tokens by sending transactions
//   5. Renders the whole application
//
// Note that (3) and (4) are specific of this sample application, but they show
// you how to keep your Dapp and contract's state in sync,  and how to send a
// transaction.
export class Arcade extends React.Component {
  render() {
    return (
      <>
        <header className="header-section">
          <div className="container">
            <div className="header-holder">
              <div className="header-primary d-flex flex-wrap justify-content-between align-items-center">
                <div className="brand-logo d-none d-lg-inline-block">
                  <div className="logo">
                    <Link to="/">
                      <img
                        src={smallLogo}
                        alt="logo"
                        width={100}
                        height={100}
                      />
                    </Link>
                  </div>
                </div>
                <div className="header-wrapper justify-content-lg-end">
                  <div className="mobile-logo d-lg-none">
                    <a href="index.html">
                      <img
                        src={smallLogo}
                        alt="logo"
                        width={100}
                        height={100}
                      />
                    </a>
                  </div>

                  <div className="menu-area">
                    <ul className="menu">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                    </ul>

                    <div className="header-bar d-lg-none">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        {/* // Dashboard Header */}
        <section className="banner padding-bottom padding-top" id="arcade">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-12 text-left">
                <div
                  className="banner__content text-left"
                  data-aos="zoom-in"
                  data-aos-duration="900"
                >
                  <h1>The Arcade Lounge</h1>
                  <h3>The wait is almost over.</h3>
                </div>
                <div id="videoBG"></div>
                <canvas id="canvas" className="text-center wave-bg"></canvas>
                <Video vidSrc={bgArcade} />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
export default Arcade;
